import BaseClass from "../../libs/base/BaseClass";
import Util from "../../libs/util/Util";
import SliderPointerClass from "./SliderPointerClass";

/**
 * css_slider 管理
 */
export default class PriceSliderClass extends BaseClass{
    constructor(_target){
        super();
        this.name = "PriceSliderClass";
        this.EVENT_CHANGE = "eventChange";

        this.target = _target;

        this.parts = {};

        this.isChange = false;

        this.points = {
            a:0,
            b:1
        }
    }

    onCreate() {
        //console.log(this.target);

        this.min = parseFloat(this.target.attr("data-a"));
        this.max = parseFloat(this.target.attr("data-b"));

        let isDefaultSet = true;
        this.defaultMin = parseFloat(this.target.attr("data-a_default"));
        this.defaultMax = parseFloat(this.target.attr("data-b_default"));
        if(Number.isNaN(this.defaultMin) || Number.isNaN(this.defaultMax) || (this.defaultMin >= this.defaultMax) ||
            (this.defaultMin < this.min) || (this.defaultMax > this.max)){
            this.defaultMin = null;
            this.defaultMax = null;
            isDefaultSet = false;
        }

        this.baseValDiff = this.max - this.min;

        this.$slider = $(".slider_body",this.target);
        this.$barWrap = $(".bg",this.$slider);
        this.$bar = $(".bar",this.$slider);
        this.$pointA = $(".point.a",this.$slider);
        this.$pointB = $(".point.b",this.$slider);

        this.$valueA = $(".value .a",this.target);
        this.$valueB = $(".value .b",this.target);

        this.$inputA = $("[data-point=a]",this.target);
        this.$inputB = $("[data-point=b]",this.target);

        this.pointA = new SliderPointerClass(this.$pointA,true);
        this.pointB = new SliderPointerClass(this.$pointB,false);

        this.pointA.onCreate();
        this.pointB.onCreate();

        this.pointA.on(this.pointA.EVENT_CHANGE,(e,p)=>{
            //console.log(this.name,p);
            const val = Math.floor(this.baseValDiff * p.par) + this.min;
            this.$inputA.val(val);
            this.$valueA.text(Util.numberToPrice(val)+"〜");
            this.pointB.onOtherChange(1 - p.par);

            this.points.a = p.par;
            this.changeBarSize();
            this.jq.trigger(this.EVENT_CHANGE);
        });

        this.pointB.on(this.pointB.EVENT_CHANGE,(e,p)=>{
            //console.log(this.name,p);
            const val = Math.floor(this.baseValDiff * p.par) + this.min;
            this.$inputB.val(val);
            this.$valueB.text("〜"+Util.numberToPrice(val));
            this.pointA.onOtherChange(p.par);

            this.points.b = p.par;
            this.changeBarSize();
            this.jq.trigger(this.EVENT_CHANGE);
        });

        this.$inputA.val(this.min);
        this.$inputB.val(this.max);

        this.onSetTextValue(this.min,this.max);

        if(isDefaultSet){
            const minPar = (this.defaultMin - this.min)/this.baseValDiff;
            const maxPar = (this.defaultMax - this.min)/this.baseValDiff;
            this.pointA.setDefault(minPar);
            this.pointB.setDefault(maxPar);
        }
    }

    onResize() {
        const size = {w:this.$barWrap.width(),h:1,pointWidth:$("span",this.$pointA).outerWidth()};

        this.pointA.onResize(size);
        this.pointB.onResize(size);
    }

    onReset(){
        this.pointA.onReset();
        this.pointB.onReset();
        this.$inputA.val("");
        this.$inputB.val("");
        this.points = {
            a:0,
            b:1
        };
        this.changeBarSize();
        this.onSetTextValue(this.min,this.max);
    }

    onSetTextValue(_a,_b){
        this.$valueA.text(Util.numberToPrice(_a)+"〜");
        this.$valueB.text("〜"+Util.numberToPrice(_b));
    }

    getChangeFlag(){
        return this.isChange;//(this.pointA.nowPar !== 0 || this.pointB.nowPar !== 0);
    }

    changeBarSize(){
        this.isChange = true;
        const left = this.points.a*100;
        const right = (1-this.points.b) * 100;
        this.$bar.css({left:left+"%",right:right+"%"});
    }

}